import * as _ from "underscore";
import environment from "flow/configuration/environment";
import componentCache from "flow/utils/componentCache";
import ICLICommand from "flow/interfaces/ICLICommand";

const setInspectionStatus = function (enable: boolean) {
    // For new components
    environment.set(environment.keys.inspector, enable);

    // Update existing components
    Object.values(componentCache.getComponents()).forEach(c => {
        c.inspectionEnabled(enable);
    });

    // Update existing components loaded but not cached (reuseInstance = false)
    componentCache.getInstances().forEach(i => {
        i.inspectionEnabled(enable);
    });
};

export default {
    name: "inspector",
    description: "Enables/disables inspection of view models",
    options: [
        {
            name: "enable",
            shortName: "e",
            description: "Enables inspector"
        },
        {
            name: "disable",
            shortName: "d",
            description: "Disables inspector"
        }
    ],
    arguments: [],
    callback: (writer, optsAndArgs) => {
        if (optsAndArgs.enable) {
            setInspectionStatus(true);
            writer.output.writeLine("Inspector is enabled.");
        } else if (optsAndArgs.disable) {
            setInspectionStatus(false);
            writer.output.writeLine("Inspector is disabled.");
        } else {
            if (environment.isEnabled(environment.keys.inspector)) {
                writer.output.writeLine("Inspector is currently enabled.");
                writer.output.writeLine("Disable with -d.");
            } else {
                writer.output.writeLine("Inspector is currently disabled.");
                writer.output.writeLine("Enable with -e.");
            }
        }

        return { input: "" };
    }
} as ICLICommand;
